<template>
  <transition name="fade">
    <div class="dialog">
      <dialog-close-button v-if="showCloseButton" :hide-modal="hideModal"></dialog-close-button>
      <h2 v-if="title" class="iw-page-title m-b-30" v-html="title"></h2>
      <p class="dialog__text iw-body-text-large" v-html="text"></p>
      <div v-if="buttons.length" class="dialog__button-bar">
        <app-button
          v-for="(button, index) in buttons"
          :key="index"
          :ref="'dialog-button'"
          :text="button.title"
          :aria-label="button.title"
          :handler="button.handler"
          class="dialog__button"
          :outlined="primaryAction(index, buttons)"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import DialogCloseButton from "./DialogCloseButton";

export default {
  name: "Dialog",
  components: {
    DialogCloseButton
  },
  props: {
    showCloseButton: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    buttons: {
      type: Array,
      default: () => []
    },
    showFirstActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hideModal() {
      this.$modal.hide();
    },
    primaryAction(index, buttons) {
      return this.showFirstActive ? index > 0 : index < buttons.length - 1;
    }
  }
};
</script>

<style lang="scss">
.dialog {
  padding: 50px;
  text-align: center;
  word-wrap: break-word;

  &__text {
    margin: 0;
    line-height: 22px;
  }

  &__button-bar {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 20px;
  }

  .dialog__button {
    width: 150px;
    margin: 0 auto;

    @include respond-to-mobile {
      width: 100%;
    }
  }
}
</style>
